@if(data) {
    <div class="dialog confirm">
        <div class="dialog-title">
           <h2>{{ data.headline |translate}}</h2>
            <button mat-icon-button (click)="close()"><mat-icon  fontIcon="close"></mat-icon></button>
        </div>
        <mat-dialog-content>
            <span>{{ data.mess1 | translate}}</span>  <span>{{ data.mess2 | translate}}</span>  <span>{{ data.mess3 | translate}}</span>
            <div class="btn-row mt-4">
                <button mat-button (click)="close()">{{'button.cancel' | translate}}</button>
                @if(!data.btnText) {
                    <button mat-raised-button (click)="confirm()">{{'button.confirme' | translate}}</button>
                } @else {
                    <button mat-raised-button (click)="confirm()">{{ data.btnText | translate}}</button>
                }
            </div>
        </mat-dialog-content>
    </div>
}
